// Generated by purs version 0.15.15
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_CoreSites_Translations_Keys from "../Restaumatic.CoreSites.Translations.Keys/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var mapRecord = /* #__PURE__ */ Record_Extra.mapRecord();
var cityIsSymbol = {
    reflectSymbol: function () {
        return "city";
    }
};
var streetIsSymbol = {
    reflectSymbol: function () {
        return "street";
    }
};
var streetNumberIsSymbol = {
    reflectSymbol: function () {
        return "streetNumber";
    }
};
var StreetAddressIsSymbol = {
    reflectSymbol: function () {
        return "StreetAddress";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var StreetAddress = function (x) {
    return x;
};
var toFillFormTypeStreetAddre = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeStreetAddress_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldStreetAddress = function (dictHasField) {
    return dictHasField;
};
var getTranslationStreetAddre = function (dictHasField) {
    var getField = Data_Record.getField(dictHasField);
    return function (dictHasField1) {
        var getField1 = Data_Record.getField(dictHasField1);
        return function () {
            return function (dictMapRecord) {
                var mapRecord1 = mapRecord(dictMapRecord);
                return {
                    getTranslation: function (v) {
                        return mapRecord1(Restaumatic_I18n.translate_)(getField1(Type_Proxy["Proxy"].value)(getField(Type_Proxy["Proxy"].value)(Restaumatic_CoreSites_Translations_Keys.t)));
                    }
                };
            };
        };
    };
};
var getFieldOptionsStreetAddr = {
    getFieldOptions: function (v) {
        return {};
    }
};
var eqStreetAddress = {
    eq: function (x) {
        return function (y) {
            return x.city === y.city && x.street === y.street && x.streetNumber === y.streetNumber;
        };
    }
};
var genericStreetAddress = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showStreetAddress = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStreetAddress)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(cityIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(streetIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(streetNumberIsSymbol)(Data_Show.showString))(Data_Show.showString))(Data_Show.showString))))(StreetAddressIsSymbol))
};
var unscrambleDecodeStreetAddress = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericStreetAddress)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(cityIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(streetIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(streetNumberIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var encodeStreetAddress = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericStreetAddress)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(StreetAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(streetNumberIsSymbol)(encodeWithOptionsOther))(streetIsSymbol)(encodeWithOptionsOther))(cityIsSymbol)(encodeWithOptionsOther)))))
};
var decodeStreetAddress = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericStreetAddress)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(StreetAddressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(streetNumberIsSymbol)(decodeWithOptionsOther)())(streetIsSymbol)(decodeWithOptionsOther)())(cityIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    StreetAddress,
    getTranslationStreetAddre,
    getFieldOptionsStreetAddr,
    genericStreetAddress,
    eqStreetAddress,
    showStreetAddress,
    encodeStreetAddress,
    decodeStreetAddress,
    unscrambleDecodeStreetAddress,
    toFillFormTypeStreetAddre,
    hasFieldStreetAddress,
    newtypeStreetAddress_
};
